'use strict';

angular.module('adelementAdminApp')
    .controller('ExcludedFieldDetailController', function ($scope, $rootScope, $stateParams, entity, ExcludedField) {
        $scope.excludedField = entity;
        $scope.load = function (id) {
            ExcludedField.get({id: id}, function(result) {
                $scope.excludedField = result;
            });
        };
        var unsubscribe = $rootScope.$on('adelementAdminApp:excludedFieldUpdate', function(event, result) {
            $scope.excludedField = result;
        });
        $scope.$on('$destroy', unsubscribe);

    });
